import { Text } from '@tectonic/elemason-components';
import { script } from '@tectonic/halo-script';
import { CurrencyCode, LocalStateKeys } from '@tectonic/types';
import { access, toCurrency } from '@tectonic/utils';
import { useHaloScript } from '../../../hooks/useHaloScript';

import type { Cart, ElemasonCartShippingCalloutWidget } from '@tectonic/types';
import type { FC } from 'react';

const STATE_KEY = LocalStateKeys.CART;

interface ElemasonCartShippingCalloutWidgetProps {
  widget: ElemasonCartShippingCalloutWidget;
}

// TODO: make the remaining amount configurable
const CartShippingCalloutWidget: FC<ElemasonCartShippingCalloutWidgetProps> = ({
  widget: { data, config },
}) => {
  const cart = useHaloScript<Cart>(script([access(['local', STATE_KEY])]));
  const freeTextPlaceholders = useHaloScript<Record<string, string>>(
    data?.freeText?.placeholders
  );
  const remainingTextPlaceholders = useHaloScript<Record<string, string>>(
    data?.remainingText?.placeholders
  );
  const remainingAmount = 599 - (cart?.cost.estimatedTotalAmount.amount ?? 0);

  return (
    <Text
      data={
        remainingAmount > 0 ? data?.remainingText?.text : data?.freeText?.text
      }
      placeholders={{
        ...(remainingAmount > 0
          ? remainingTextPlaceholders
          : freeTextPlaceholders),
        remaining: toCurrency(remainingAmount, CurrencyCode.BDT),
      }}
      config={config?.text}
    />
  );
};

export { CartShippingCalloutWidget };
